<template>
<ButtonSecondary v-on="$listeners" class="v-btn--action">
  <template v-slot:icon>
    <AddIconSimple/>
  </template>
  <template v-slot:text>
    {{$t('buttons.addNewField')}}
  </template>    
</ButtonSecondary>
</template>

<script>
import ButtonSecondary from "./templates/ButtonTertiary";
import AddIconSimple from "../icons/AddIconSimple";
export default {
  name: "ButtonTertiaryAction",
  components: {AddIconSimple, ButtonSecondary}
}
</script>

<style scoped lang="scss">
</style>

<!-- The following style have to be declared as global styles, otherwise they have no effect. -->
<style lang="scss">
.v-btn--action {
  svg.add-icon-simple {
    .a {
      fill: #878787;
    }
  }

  &:hover {
    svg.add-icon-simple {
      .a {
        fill: #050505;
      }
    }
  }
}
</style>
